import { useQuery } from '@tanstack/react-query'
import { apiGetLicenses } from '~/api/adminApi'
import { showErrors } from '~/utils/helpers'

export const useLicensesQuery = () => useQuery({
  queryKey: ['licenses', 'list'],
  queryFn: async () => await apiGetLicenses(),
  onError: showErrors,
  refetchOnWindowFocus: false
})
